<template>
	<div class="content-wrapper">
		<div class="sf-col-15" style="display: flex; justify-content: space-evenly">
			<!-- 그래프 부분 시작 -->
			<el-row :gutter="30">
				<el-col :span="8">
					<div class="sf-col">
						<sf-card class="p-0 border-0 bg-transparent">
							<pc-pcm-tap-flc-graph class="mb-3" ref="graph" :scrId="scrId"></pc-pcm-tap-flc-graph>
						</sf-card>
					</div>
				</el-col>
				<el-col :span="16">
					<sf-card class="p-0 border-0 bg-transparent" height="330px">
						<pc-pcm-tap-flc-table ref="table" :scrId="scrId"></pc-pcm-tap-flc-table>
					</sf-card>
				</el-col>
			</el-row>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcPcmTapFlcGraph from './PcPcmTapFlcGraph.vue';
import PcPcmTapFlcTable from './PcPcmTapFlcTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: { PcPcmTapFlcGraph, PcPcmTapFlcTable },
	methods: {}
};
</script>

<style></style>
